<style scoped  lang="less"> 
   @import 'detailsHead.less';  

</style>
<template>
  <div v-if="match"> 
    <div class="gameHeadBox"   :class="(isHeadDown?'gameHeadBox_on':'')+' '+(!(match.state==4&&scoreData)?'gameHeadBox_score':'')">
      <!-- :class="isHeadDown?'gameHead_on':''" -->
      <div class="gameHead " ref="ref_gameHead"  :class="isHeadDown?'gameHead_on':''" v-if="match!=null">
          <!-- 主队 -->
          <div class="team">
            <img  :src="common.teamImgGet(match['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt="">
            <span>{{match['homeTeam']['fullName']}}</span>
          </div>
          <!-- 信息 -->
          <div class="message">
            <div class="time">
              <!-- {{common.dateStr(match.startTime,'dd/MM/YYYY HH:mm')}} -->
              {{getGameTime(match.startTime)}}
            </div>
            <!-- 未开始 -->
            <div class="scoreVs" v-if="[0,17].indexOf(match.state*1)>-1">
              <p class="green" :class="countdown.p1!=24?'p1':''">{{countdown.text}}</p>
            </div>
            <div class="scoreVs" v-if="[5,6,13,14,15].indexOf(match.state*1)>-1"> 
              <p>{{langConfig.details[langConfig.curLang]['COUNT_DOWN'][match.state]}}</p>
            </div>
            <!--  //比赛状态 1上半场 2中场休息 3下半场 4完场 5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 17未开赛 -->
            <!-- 比分数据 -->
            <div class="score" v-if="[1,2,3,4,8,11].indexOf(match.state*1)>-1">
              <!-- 顶部 -->
                <div class="scoreNum " :class="isScoreNum('h')?'scoreNum_end':''">{{match.homeLive['scoreFull']?match.homeLive['scoreFull']:0}}</div>
                <div class="scorebox">
                  <div class="sb_time">
                    <template  v-if="[1,3].indexOf(match.state*1)>-1">{{ingData}}</template>
                    <span>{{langConfig.txtLang[langConfig.curLang]['STATE_ARR'][match.state]}}</span>
                  </div>
                  <p class="sb_half" v-if="isScoreHalf()">
                    （HT {{match.homeLive['scoreHalf']?match.homeLive['scoreHalf']:0}}:{{match.awayLive['scoreHalf']?match.awayLive['scoreHalf']:0}}）
                  </p>
                </div>
                <div class="scoreNum " :class="isScoreNum('a')?'scoreNum_end':''">{{match.awayLive['scoreFull']?match.awayLive['scoreFull']:0}}</div>
            </div>
            <!-- 底部 -->
            <div class="scoreData" v-if="match.state==4"> 
              <span>
                {{scoreData}}
              </span>
            </div>
          </div>
          <!-- 客队 -->
          <div class="team">
            
            <img  :src="common.teamImgGet(match['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt="">
            <span>{{match['awayTeam']['fullName']}}</span>
          </div>
          <div class="collect" v-if="match&&!([5,6,13,14,15].indexOf(match.state*1)>-1)&&!isAfter7Days(match.startTime)">
            <a href="javascript:void(0);" :class="follow===true?'on':''" @click="collect();"  v-if="[1,2,3,8,11,17].indexOf(match.state*1)>-1"></a> 
            <!-- <a href="javascript:void(0);" :class="follow===true?'on':''" @click="collect();"  v-if="[4].indexOf(match.state*1)>-1&&follow==true"></a>  -->
            <!-- <a class="in" v-if="[4].indexOf(match.state*1)>-1&&follow==false"></a>  -->
          </div> 
      </div>
    </div>
    <div>
   
    </div>  
     <!-- <a href="javascript:void(0);" @click="aaaa">222</a>  -->
    <Login :loginShow="loginShow"  />
  </div>
</template>

<script>
  import Login from '@/components/login.vue';
export default {
  components: {
      Login
  },
  data() {
    return {
      countdown:{ 
        text:'',// countdown.text
        timeDiff:0,
        p1:24
      },
      countdownTimer:0,
      scoreData:'',
      ingData:'',
      ingTimer:0,
      ingtime:-1,
      follow:-1,
      loginShow:false,
      startTime:'',
      isDownShow:false,
      timeGap:null,
    };
  },
  methods: { 
    // 是否7天后的比赛
    isAfter7Days(startTime) {
      const startDate = new Date(startTime * 1000);
      startDate.setDate(startDate.getDate() - 7); // 7天后
      const currentDate = new Date();
      return startDate > currentDate;
    },
    getGameTime(startTime){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      var _dateForm = 'dd/MM/YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      if(this.langConfig.curLang == 'kr'){
        _dateForm = 'YYYY-MM-dd HH:mm';
      }
      //console.log();
      // setting=JSON.parse(setting);
      // var aa=this.common.getDateByArray(_tz, match.startTime)
      //

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      return _time;

    },
    collect(){
      
      var _this=this;
      if(typeof window =='undefined'){
        return;
      }
      let isFollow=JSON.parse(JSON.stringify(this.isFollow));
      let follow=JSON.parse(JSON.stringify(this.follow));
      let match=JSON.parse(JSON.stringify(this.match));
      //console.log('match',match);
  
      if(follow==-1){
        follow=isFollow;
      }
      var operationData=(follow?2:1);//1=添加 2=删除

      if(match.state==4&&follow){
        operationData=2;
      }
     // let _isLoginPm = this.common.isLogin(); // 是否登录Promise
     _this.loginShow = false;
      this.common.isLogin().then((res)=>{ // res返回true,false
        //console.log('_isLogin11',res);
        let _isLogin = res;
        if(_isLogin){// 已登录
          //console.log('已登录');
          _this.common.followMatch({
            matchId: match.matchId,
					  operation: operationData,
            callback:function(val){
              //console.log('callback',val);
              if(val.state==200){
                _this.follow=!follow;
                if(operationData==2){//取消
                  _this.$message({
                      dangerouslyUseHTMLString: true,
                      message: this.langConfig.index[this.langConfig.curLang]['REMOVED_MY_FAVORITES'],
                      type: 'success',
                      iconClass: 'icon-font event-fav favDelIcon',
                      customClass: 'favSuccess',
                      //offset: (document.documentElement.clientHeight - 50),
                      duration: 5000
                    });
                }else{
                  _this.$message({
                    dangerouslyUseHTMLString: true,
                    message: this.langConfig.index[this.langConfig.curLang]['ADD_MY_FAVORITES'],
                    type: 'success',
                    iconClass: 'icon-font icon-collectStar favSuccessIcon',
                    customClass: 'favSuccess',
                    //offset: (document.documentElement.clientHeight - 50),
                    duration: 5000
                  });
                }
              }else if(val.state==400){
                _this.loginShow = true;
              }
            }
          })
        }else{//wei登录
          _this.loginShow = true;
          //console.log('no登录');
        }
      })
      //console.log('_this.loginShow',_this.loginShow);
      //this.follow=true;
  

    },
    aaaa(){
      //console.log('match',this.follow);
      // this.checkgameHeadView();
      // const element = this.$refs.gameHead;
      // const topOffset = element.getBoundingClientRect();
      //console.log('topOffset',topOffset.top,topOffset);
      // this.$message({
      //   dangerouslyUseHTMLString: true,
      //   message: '<div><span>Removed from My Favorites.</span></div>',
      //   type: 'success',
      //   iconClass: 'icon-font event-fav favDelIcon',
      //   customClass: 'favSuccess',
      //   //offset: (document.documentElement.clientHeight - 50),
      //   duration: 5000
      // });

      this.$message({
                  dangerouslyUseHTMLString: true,
                  message: this.langConfig.index[this.langConfig.curLang]['ADD_MY_FAVORITES'],
                  type: 'success',
                  iconClass: 'icon-font icon-collectStar favSuccessIcon',
                  customClass: 'favSuccess',
                  //offset: (document.documentElement.clientHeight - 50),
                  duration: 5000
                });
    },
    isScoreNum(live){
      const { awayLive, homeLive } = JSON.parse(JSON.stringify(this.match));
      const scoreFull_a = awayLive?.scoreFull || 0;
      const scoreFull_h = homeLive?.scoreFull || 0;
      if (scoreFull_h !== 0 && scoreFull_a !== 0) {
        if (scoreFull_h > scoreFull_a) {
          return live === 'h';
        } else if (scoreFull_h < scoreFull_a) {
          return live === 'a';
        }
      }
      return false;
    },
    //判断是否为半场
    isScoreHalf(){
      let match=JSON.parse(JSON.stringify(this.match));
      return match.homeLive['scoreHalf']!=undefined||match.awayLive['scoreHalf']!=undefined
    },
    //倒计时
    updateCountdown(type){
      let match=JSON.parse(JSON.stringify(this.match));
      //console.log('match',match);
      //console.log('match2',this.match);
      var _this=this;
      let countdown=JSON.parse(JSON.stringify(this.countdown));
      if(type==(-1)){
        // countdown.timeDiff=match.startTime-match.serverTimestamp;
        if(countdown.timeDiffserver==null){
          countdown.timeDiffserver=match.serverTimestamp-Math.floor(Date.now() / 1000)
        }
        //console.log('aaaa',countdown.timeDiff);
      }
      countdown.timeDiff=match.startTime-Math.floor(Date.now() / 1000)+(countdown.timeDiffserver?countdown.timeDiffserver:0);
      //console.log('countdown.timeDiffserver',countdown.timeDiffserver,'fuwuqi',match.serverTimestamp,countdown.timeDiff);
      //console.log('countdown111',match.serverTimestamp);
   
      clearTimeout(this.countdownTimer); // 取消定时器
      if(countdown.timeDiff>0){
        const timeDiff=countdown.timeDiff;
        const hours = Math.floor(timeDiff / ( 60 * 60));
        const minutes = Math.floor((timeDiff % ( 60 * 60)) / ( 60));
        const seconds = Math.floor((timeDiff % ( 60)) / 1);
        var timeOut=1000;
        if(hours<24){
          countdown.p1=24;
          countdown.text=(hours<10?'0'+''+hours:hours)+':'+(minutes<10?'0'+''+minutes:minutes)+':'+(seconds<10?'0'+''+seconds:seconds);
        }else if(24<=hours&&hours<48){

          countdown.p1=48;
          countdown.text=this.langConfig.details[this.langConfig.curLang]['COUNT_DOWN']['tomorrow'];//'明天开赛';
          // timeOut=24*3600*1000;
        }else if(48<=hours&&hours<72){
          countdown.p1=72;
          countdown.text=this.langConfig.details[this.langConfig.curLang]['COUNT_DOWN']['after_tomorrow']//'后天开赛';
          // timeOut=24*3600*1000;
        }else if(72<=hours){

          countdown.p1=73;
          countdown.text=this.langConfig.details[this.langConfig.curLang]['COUNT_DOWN'].nDays(Math.ceil(hours/24));//Math.ceil(hours/24)+'天后开赛';
          // timeOut=24*3600*1000;
        }
        // countdown.timeDiff--;
        //console.log('countdown.timeDiff',countdown.timeDiff);
        this.countdownTimer=setTimeout(function() {
          _this.updateCountdown();
        }, timeOut);
      }else{
        countdown.text='00:00:00'
      }
      //console.log('countdown',countdown);
      this.countdown=countdown;
    },
    // 获取比赛时间
    gameTime(state,time, realtime, svrtime){
      let _start = state, _titme = time, _realtime = realtime, _svrtime = svrtime;
      if([1,3].indexOf(_start)>-1){//上下半场
        let _start = state, _titme = time, _realtime = realtime, _svrtime = svrtime;
        var bssj = 0;
        if(typeof(_realtime) != 'undefined'){
          _titme = _realtime;
        }
        if(_start==1){
          bssj = parseInt((_svrtime - _titme) / 60);
          if (bssj < 0)
            bssj = 0;
          if (bssj > 45)
            bssj = 45;
        }else{
          bssj = parseInt((_svrtime - _titme) / 60) + 45;
          if (bssj < 46)
            bssj = 46;
          if (bssj > 90)
            bssj = 90;
        }
        return bssj;
      }
      return "";
    },
    // 服务器和客户端时间差  
    timeDiff(svrTimestamp){
      if(this.timeGap!=null){return;}
      let _svr = new Date(this.common.jsonParse(svrTimestamp)*1000), _clt = new Date();
      //console.log('服务器时间', _svr)
      this.timeGap = parseInt((_svr - _clt) / 1000 / 60);
      //console.log('时间差', this.timeGap)
    },
    // 比赛进行时间
    ingTimeFn(){
      var _this=this;
      //时区
      var _tsz = '+08:00' 
      var setting=_this.common.getCookie('setting');   
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let match=JSON.parse(JSON.stringify(this.match));
      let state=match.state*1;//状态
      let svrtime=match.serverTimestamp;//服务器时间
     
      let time=match.startTime;//开始时间
      let realtime=match.startHalfTime;//半场时间
      var ingData='';
      if([1,3].indexOf(state*1)>-1){//上下半场
        // 专题太              开始            半场                      服务器
        // let _start = state, 
        // _titme = time, 
        // _realtime = realtime, 
        // _svrtime = svrtime;
        // let _start = _val['state'],
        let _titme = this.common.getDateByArray(_tsz, match['startTime']);
        let _realtime = this.common.getDateByArray(_tsz, match.startHalfTime);
        let _injuryTime = match['injuryTime'];
        //   _svrtime = this.common.getDateByArray(_tsz, svrtime), 
        let _nowtitme = this.common.getDateByArray(_tsz, Date.parse(new Date())/1000);

        var bssj = 1;

          if(typeof(_realtime) != 'undefined' && typeof(match.startHalfTime) != 'undefined'){
            _titme = _realtime;
          }

          if(state==1){
            bssj = parseInt((_nowtitme - _titme) / 60) + (this.timeGap?this.timeGap:0);
            if (bssj < 1){
              bssj = 1;
            }
            if (bssj > 45){
              bssj = 45;
            }
          }else{
            bssj = parseInt((_nowtitme - _titme) / 60) + 45 + (this.timeGap?this.timeGap:0);
            if (bssj < 46){
              bssj = 46;
            }
            if (bssj > 90){
              bssj = 90;
            }
          }
          
          if(typeof(_injuryTime) != 'undefined' && bssj == 90){
            ingData = "90+'";
          }else{
            ingData = bssj+''+"'";
          }
          
      

        // var bssj = 0;
        // if(typeof(realtime) != 'undefined'){
        //   time = realtime;
        // }
        // if(state==1){
        //   bssj = parseInt((svrtime - time) / 60);
        //   if (bssj < 0)
        //     bssj = 0;
        //   if (bssj > 45)
        //     bssj = 45;
        // }else{
        //   bssj = parseInt((svrtime - time) / 60) + 45;
        //   if (bssj < 46)
        //     bssj = 46;
        //   if (bssj > 90)
        //     bssj = 90;
        // }
        this.ingtime=bssj*1;
        // ingData=bssj+ (match.injuryTime?'+':'')+"'";
      }else{
        ingData='';
      }
      //console.log('ingData',ingData);
      var ingTime=this.$route.query.ingTime;
      if(ingTime){
        //console.log('ingData',ingData);
      }
      this.ingData=ingData;
      clearTimeout(this.ingTimer);
      if([1,3].indexOf(state*1)>-1){
        this.ingTimer=setTimeout(function() {
          // _this.ingTimeAdd();
          _this.ingTimeFn();
        }, 6*1000);
      }
    },
    ingTimeAdd(){
      var _this=this;
      let match=JSON.parse(JSON.stringify(this.match));
      let ingtime=JSON.parse(JSON.stringify(this.ingtime));
      let state=match.state*1;
      clearTimeout(this.ingTimer);
      ingtime=ingtime*1+1;
      if (state == 1) {
        ingtime = ingtime > 45 ? 45 : ingtime;
      }
      if (state == 3) {
        ingtime = ingtime > 90 ? 90 : (ingtime < 45 ? 45 : ingtime);
      }
      this.ingtime=ingtime;
      this.ingData=ingtime*1+ (match.injuryTime?'+':'')+"'";
      if([1,3].indexOf(state*1)>-1){
        this.ingTimer=setTimeout(function() {
          _this.ingTimeAdd();
        }, 60*1000);
      }
    },
    checkgameHeadView() {
      //console.log('checkgameHeadView',typeof window!='undefined');
      var _this=this;
      //console.log('checkgameHeadVi222ew',typeof window!='undefined',window.innerHeight);
      if(typeof window!='undefined'){
        //console.log('checkgameHeadView',111);
        // var gameHead = _this.$refs.gameHead_ref;
        //console.log('gameHead',gameHead);
        // if (gameHead) {
        //   var rect = gameHead.getBoundingClientRect();
        //console.log('rect.top',rect);
        //   _this.isDownShow = rect.top >= 1 && rect.bottom <= window.innerHeight;
        // } 
        const ref_gameHead = _this.$refs.ref_gameHead;
        //console.log('ref_gameHead',ref_gameHead);
        if(ref_gameHead){
          const topOffset = ref_gameHead.getBoundingClientRect();
          //console.log('topOffsref_gameHead',topOffset.top,topOffset.bottom,window.innerHeight);
          //console.log('topOffset.offsetTop11',_this.$refs.ref_gameHead.$el);
          //console.log('ididididid',topOffset.top <= 0 && topOffset.bottom >= window.innerHeight);
          // _this.isDownShow = topOffset.top <= 0 && topOffset.bottom <= window.innerHeight;
            var isDownShow=topOffset.top <0 &&topOffset.bottom<= window.innerHeight;
            if(isDownShow!=this.isDownShow){
              if(isDownShow){
                  window.scrollTo({
                  top: topOffset.offsetTop,
                  // behavior: 'smooth', // 添加这个可以实现平滑滚动
                });
              }
            }
            _this.isDownShow = isDownShow;
           
            
         
          // const element = this.$refs.gameHead;
          // const topOffset = element.getBoundingClientRect();
          //console.log('topOffset',topOffset.top,topOffset);
        }
       
        
   
      }
    },
    init(){
      this.updateCountdown(-1);//倒计时
      //this.checkgameHeadView();
      let match=JSON.parse(JSON.stringify(this.match));
      this.timeDiff(match.serverTimestamp);
      //拼接scoreData
      function isObject(myObject){
        if (typeof myObject !== "undefined" && myObject !== null) {
          return true;
        }else{
          return false;
        }
      }
      var scoreData=``;
      if(isObject(match.homeLive['scoreFull'] || 0) || isObject(match.awayLive['scoreFull'] || 0)){
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['90min'].replace('?1', match.homeLive['scoreFull'] || 0).replace('?2', match.awayLive['scoreFull'] || 0);
      }
      if(isObject(match.homeLive['scoreRound1'])&&isObject(match.awayLive['scoreRound1'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['first'].replace('?1', match.homeLive['scoreRound1']).replace('?2', match.awayLive['scoreRound1']);
      }
      if(isObject(match.homeLive['scoreRound2'])&&isObject(match.awayLive['scoreRound2'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['second'].replace('?1', match.homeLive['scoreRound2']).replace('?2', match.awayLive['scoreRound2']);
      }
      if(isObject(match.homeLive['scoreOt'])&&isObject(match.awayLive['scoreOt'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['120min'].replace('?1', match.homeLive['scoreOt']).replace('?2', match.awayLive['scoreOt']);
      } 
      if(isObject(match.homeLive['scorePen'])&&isObject(match.awayLive['scorePen'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['penalyty'].replace('?1', match.homeLive['scorePen']).replace('?2', match.awayLive['scorePen']);
      }
      //console.log('scoreData',scoreData);
      this.scoreData=scoreData.split(',').filter(item => item != " ").join();
      //状态
      this.ingTimeFn();
      //收藏状态
      let isFollow=JSON.parse(JSON.stringify(this.isFollow));
      let follow=JSON.parse(JSON.stringify(this.follow));
      //console.log('follow11',follow,isFollow);
      if(follow==-1){
        this.follow=isFollow;
      }
    },
  },
  created() {

  },
  watch: {
    match(val){
      this.init(); 
    },
    isFollow(val){
      if(val){
        this.follow=true;
      }
    }
  },
  mounted() {
    // var _this=this;
    // if(typeof window!='undefined'){
    //   window.addEventListener('scroll',  _this.common.debounce(_this.checkgameHeadView,10));
    // }
  },
  beforeDestroy() {
    // if(typeof window!='undefined'){
    //   window.removeEventListener('scroll', this.checkgameHeadView);
    // }
  },
  props: {
    // format: {
    //   type: String,
    //   default:'DD/MM/YYYY WW'
    // },
    isFollow:{
      type: Boolean,
      default:false
    },
    match: {
      type: Object,
      default:null
    }, 
    // options:{
    //   type:Array,
    //   default:() =>[],
    // },
    // format: {
    //   type: String,
    //   default:'DD/MM/YYYY WW'
    // },
    isHeadDown:{
      type: Boolean,
      default:false
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsHead.vue